import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { lessonFormats } from '../../data/homeContent';
export function LessonsSection() {
  return <section aria-labelledby="cours-title" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-49" data-mp="1o19cwvqfe4ry">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-50" data-mp="1j2xzkb0x9c4z">
        <h2 id="cours-title" className="font-display text-4xl font-medium leading-tight md:text-5xl lg:col-span-6" data-id="element-51" data-mp="1j4iyecu9rh8n">
          Cours de violoncelle
        </h2>
        <p className="max-w-lg leading-relaxed text-ink-soft lg:col-span-5 lg:col-start-8" data-id="element-52" data-mp="1a9cl6sso5ww3">
          Pour commencer, reprendre ou progresser. Le premier rendez-vous est un échange : on écoute
          votre jeu, vos envies, et on construit le parcours ensemble.
        </p>
      </div>

      <table className="mt-14 w-full border-collapse text-left" data-id="element-53" data-mp="vd3rs7vgmdrl">
        <caption className="sr-only" data-id="element-54" data-mp="rb8m6r6hxe80">Formules de cours de violoncelle</caption>
        <thead className="sr-only" data-id="element-55" data-mp="rdd081y3ztm0">
          <tr data-id="element-56" data-mp="2ewpkv50mnwk0">
            <th scope="col" data-id="element-57" data-mp="2ew6g6pzzn4nx">Formule</th>
            <th scope="col" data-id="element-58" data-mp="2ev4qpgi86fmo">Pour qui</th>
            <th scope="col" data-id="element-59" data-mp="2jog2zx5t3olz">Durée</th>
          </tr>
        </thead>
        <tbody data-id="element-60" data-mp="2jpr5ltnimqbi">
          {lessonFormats.map(format => <tr key={format.name} className="flex flex-col gap-1 border-t border-line py-7 md:table-row md:py-0" data-id="element-61" data-mp="250cscagtjoqu">
              <th scope="row" className="font-display text-2xl font-medium md:w-[34%] md:py-8 md:align-top md:text-3xl" data-id="element-62" data-mp="29yecyztw7w4f">
                {format.name}
              </th>
              <td className="text-ink-soft md:py-8 md:pr-8 md:align-top md:leading-relaxed" data-id="element-63" data-mp="32lqz58w561x7">{format.detail}</td>
              <td className="text-sm font-medium text-wood md:w-40 md:py-8 md:text-right md:align-top" data-id="element-64" data-mp="2om978knju8jm">
                {format.duration}
              </td>
            </tr>)}
        </tbody>
      </table>

      <div className="border-t border-line pt-10" data-id="element-65" data-mp="1d6kipound1gp">
        <Link to="/cours" className="inline-flex items-center gap-2 text-sm font-medium text-ink transition-colors duration-150 hover:text-wood" data-id="element-66" data-mp="1h9yzwiubnnvq">
          Tarifs et modalités
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="3ewrq4n5tsw09" />
        </Link>
      </div>
    </section>;
}